module.exports = __webpack_public_path__ + "dd55ea0a2e90d5d86e15444a623c385a.woff2";